export default __webpack_public_path__ + "static/media/SCIENCE_REMIX.646547b0.svg";